import { Component } from "react";

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
export default class NoBodyBackgroundColor extends Component {
  componentDidMount() {
    if (document) {
      this.backgroundColor = document.body.style.backgroundColor;
      document.body.style.backgroundColor = "transparent";
    }
  }

  componentWillUnmount() {
    if (document) {
      document.body.style.backgroundColor = this.backgroundColor;
    }
  }

  // eslint-disable-next-line
  render() {
    return null;
  }

  backgroundColor: string;
}
